import type { ContentBlock } from "@calega/content";

export function ContentBlocks({ blocks }: { blocks: ContentBlock[] }) {
  return (
    <div className="content-blocks">
      {blocks.map((block) => {
        if (block.type === "heading") return block.level === 2 ? <h2 key={block.id}>{block.text}</h2> : <h3 key={block.id}>{block.text}</h3>;
        if (block.type === "paragraph") return <p key={block.id}>{block.text}</p>;
        if (block.type === "callout") {
          return <aside className={`callout ${block.tone}`} key={block.id}><strong>{block.title}</strong><p>{block.text}</p></aside>;
        }
        return <figure key={block.id}><div className="media-placeholder">Medium {block.mediaId}</div>{block.caption && <figcaption>{block.caption}</figcaption>}</figure>;
      })}
    </div>
  );
}
